// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://explorer.inkonchain.com/address/0x5C2e738F6E27bCE0F7558051Bf90605dD6176900
export const TRANSPARENT_PROXY_FACTORY = '0x5C2e738F6E27bCE0F7558051Bf90605dD6176900';

// https://explorer.inkonchain.com/address/0x00C2B13eF4F70Bf1827179Fe6d8facF7cFf6AcD2
export const PROTOCOL_GUARDIAN = '0x00C2B13eF4F70Bf1827179Fe6d8facF7cFf6AcD2';

export const CHAIN_ID = 57073;
